import React from 'react';
import { login } from '../endpoints-Calls/users/index.js';

export default function Testing() {
  const testFunction = function() {
     login("cesar@wasteplace.com","123456789");
  }
  return (
    <div>
      <button onClick={testFunction}>Test</button>
    </div>
  )
}